import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  rangeDatePicker: {
    display: 'inline-block',
    verticalAlign: 'top',
    '& .react-datepicker-popper': {
      zIndex: '100',
      minHeight: '321px',
      [breakpointsFunc.breakpoints.down('sm')]: {
        minHeight: '630px'
      }
    },
    '& .MuiFormControl-root': {
      minWidth: '250px'
    },
    '& .MuiInputBase-adornedEnd .MuiSvgIcon-root path': {
      fill: palette.shades[500]
    },
    '& .react-datepicker': {
      fontFamily: palette.fontFamilies.poppins,
      border: 'none',
      boxShadow: palette.shadows.hard,
      borderRadius: '2px',
      padding: '15px 20px',
      minHeight: '304px'
    },
    '& .react-datepicker__day': {
      backgroundColor: palette.shades[200],
      width: '33px',
      height: '33px',
      fontSize: '13px',
      lineHeight: '33px',
      color: palette.shades[700],
      borderRadius: '2px',
      margin: '1px',
      verticalAlign: 'top'
    },
    '& .react-datepicker__day-name': {
      width: '33px',
      height: '25px',
      fontSize: '12px',
      lineHeight: '25px',
      color: palette.shades[700],
      margin: '1px'
    },
    '& .react-datepicker__current-month': {
      fontSize: '15px',
      marginBottom: '15px'
    },
    '& .react-datepicker__month': {
      margin: '0 5px',
      textAlign: 'left'
    },
    '& .react-datepicker__day--keyboard-selected': {
      backgroundColor: palette.shades[200],
      color: palette.shades[700]
    },
    '& .react-datepicker__day--in-range': {
      backgroundColor: palette.primary.light,
      color: palette.shades[100]
    },
    '& .react-datepicker__day--in-selecting-range': {
      backgroundColor: palette.primary.light,
      color: palette.shades[100]
    },
    '& .react-datepicker__day--selected, .react-datepicker__day--range-end': {
      backgroundColor: palette.primary.main,
      color: palette.shades[100]
    },
    '& .react-datepicker__header': {
      backgroundColor: 'transparent',
      borderBottom: 'none',
      paddingTop: '0px'
    },
    '& .react-datepicker__day--today': {
      fontWeight: 'initial'
    },
    '& .react-datepicker__triangle': {
      display: 'none'
    },
    '& .react-datepicker__navigation--previous': {
      left: '27px',
      top: '13px'
    },
    '& .react-datepicker__navigation--next': {
      right: '27px',
      top: '13px'
    },
    '& .react-datepicker__navigation-icon::before': {
      height: '12px',
      width: '12px',
      borderColor: palette.primary.main
    },
    '& .react-datepicker__day--outside-month': {
      backgroundColor: palette.shades[100],
      opacity: '0',
      visibility: 'hidden'
    },
    '& .react-datepicker__aria-live': {
      display: 'none'
    },
    '& .react-datepicker__day--disabled': {
      opacity: '0.3'
    }
  }
});
export default useStyles;